import React from "react";

const MemoedHOC = (ComponentType, byProp = "open") => {
  const isEqual = (prevProps, nextProps) => {
    if (nextProps[byProp] === true) {
      return false;
    }
    return nextProps[byProp] === prevProps[byProp];
  };

  return React.memo(ComponentType, isEqual);
};

export default MemoedHOC;
